import React, { FC } from "react"
import "../lib/kirby.interface"
import { Block } from "./Block"

export const BlocksRenderer: FC<{
  content: string
  highlightFirst?: boolean
}> = ({ content, highlightFirst }) => {
  const blocks = JSON.parse(content) as Kirby.Block[]

  return (
    <>
      {blocks.map((block, index) => (
        <Block key={index} first={index === 0 && highlightFirst} {...block} />
      ))}

      <div style={{ clear: "both" }} />
    </>
  )
}
